/*
 * ---------------------------------------------------------------------------------
 * Copyright:
 *      NewtonGreen Technologies Pty. Ltd.
 *      Level 4, 175 Scott St.
 *      Newcastle, NSW, 2300
 *      Australia
 *
 *      E-mail: support@newtongreen.com
 *      Tel: (02) 4925 5288
 *      Fax: (02) 4925 3068
 *
 *      All Rights Reserved.
 * ---------------------------------------------------------------------------------
 */

/*
 * --------------------------------------------------------------------------------
 * This file contains a hook that proxies a hook from 
 * online-patient-management-reducers making less types required to use the hook.
 * --------------------------------------------------------------------------------
 */

/*
 * ---------------------------------------------------------------------------------
 * Imports - External
 * ---------------------------------------------------------------------------------
 */

/**
 * Required to make use of JSX functionality
 */
import * as React from 'react';


/*
 * ---------------------------------------------------------------------------------
 * Imports - Internal
 * ---------------------------------------------------------------------------------
 */

import IDtoClass from '../../utilities/IDtoClass';





import { RequestState } from '@ngt/request-utilities';




import { EventContext, EventTypeContext, FormContext, IForm, InstitutionContext as OpmsInstitutionContext, PatientContext as OpmsPatientContext } from '@ngt/online-patient-management-ui';
import InstitutionContext from '../../context/InstitutionContext';
import PatientContext from '../../context/PatientContext';
import OpmsForm from './OpmsForm';

/*
 * ---------------------------------------------------------------------------------
 * Interfaces
 * ---------------------------------------------------------------------------------
 */
interface INeonForm<Type extends IForm = any> {

    formClass: IDtoClass<Type>;
    children?: React.ReactNode;
}

/*
 * ---------------------------------------------------------------------------------
 * Styles
 * ---------------------------------------------------------------------------------
 */


/*
 * ---------------------------------------------------------------------------------
 * components
 * ---------------------------------------------------------------------------------
 */
const TrialForm = <Type extends IForm>({
    formClass,
    children

}: INeonForm<Type>) => {
    const [patient, ] = React.useContext(OpmsPatientContext);
    const [institution, ] = React.useContext(OpmsInstitutionContext);
    const [eventType, ] = React.useContext(EventTypeContext);
    const [event, ] = React.useContext(EventContext);
    const [, , formLoadState] = React.useContext(FormContext);

    const load = formLoadState.state === RequestState.Success;


    if (!load) {
        return null;
    }

    return (
        <PatientContext.Provider value={patient}>
            <InstitutionContext.Provider value={institution}>
                <OpmsForm
                    institutionId={institution?.id ?? null}
                    patientId={patient?.id ?? null}
                    eventTypeId={eventType?.id ?? null}
                    eventId={event?.id ?? null}
                    parentFormTypeId={null}
                    parentFormId={null}
                    formRepeat={1}
                    formClass={formClass}
                    readyToLoad={load}
                >
                    {children}
                </OpmsForm>
            </InstitutionContext.Provider>
        </PatientContext.Provider>
    );
}

/*
 * ---------------------------------------------------------------------------------
 * Default Export
 * ---------------------------------------------------------------------------------
 */

export default TrialForm;
